import { Preferences } from '@capacitor/preferences'
import { onMobile } from './mobile'

/**
 * 
 * @param {string} key 
 * @returns {Promise<string | null>}
 */
async function getItem(key) {
    if (onMobile) return (await Preferences.get({ key })).value
    return localStorage.getItem(key)
}

/**
 * 
 * @param {string} key 
 * @returns {Promise<void>}
 */
async function removeItem(key) {
    if (onMobile) return await Preferences.remove({ key })
    return localStorage.removeItem(key)
}

/**
 * @param {string} key 
 * @param {string} value 
 * @returns {Promise<void>}
 */
async function setItem(key, value) {
    if (onMobile) return await Preferences.set({ key, value })
    return localStorage.setItem(key, value)
}

export {
    getItem,
    removeItem,
    setItem,
}